const delivery = {
  breadcrumb: {
    delivery: "Shipping",
    settings: "Shipping settings",
    coverage: "Coverage",
    home: "My shipments",
    create: "New shipment",
    checkout: "Confirm shipment",
    detail: "Shipment details",
  },
  menu: {
    title: "Shipping",
    description: "Configure and manage your store shipments",
  },
  settings: {
    title: "Shipping settings",
    local: {
      title: "Local shipping",
      enabled: "Enable local shipping",
      price: "Shipping price",
      freeShipping: "Free shipping",
      minOrder: "Minimum order for free shipping",
    },
    national: {
      title: "National shipping",
      enabled: "Enable national shipping",
      price: "Shipping price",
      freeShipping: "Free shipping",
      minOrder: "Minimum order for free shipping",
    },
    pickup: {
      title: "Store pickup",
      enabled: "Allow store pickup",
      manageAddress: "Manage store address",
    },
    estimatedTime: {
      title: "Estimated delivery times",
      local: "Local time",
      national: "National time",
    },
    coverageLink: "Manage geographic coverage",
    save: "Save settings",
    saveSuccess: "Settings saved",
    saveError: "Failed to save",
    primeRequired: "Prime membership required for free shipping",
  },
  coverage: {
    title: "Geographic coverage",
    selectType: "Select coverage type",
    local: "Local shipping",
    national: "National shipping",
    localEnabled: "Enable local shipping",
    nationalEnabled: "Enable national shipping",
    cities: "Available cities",
    addCity: "Add city",
    cityPlaceholder: "Search city",
    noCities: "Add at least one city to enable local shipping",
    previewStore: "See how customers view it",
    save: "Save coverage",
    saveSuccess: "Coverage updated",
  },
  home: {
    title: "My shipments",
    originAddress: "Origin address",
    editAddress: "Edit address",
    newShipment: "New shipment",
    newManualShipment: "Shipment without order",
    newOrderShipment: "Shipment with order",
    settings: "Settings",
    inProgress: "In progress",
    recent: "Recent",
    empty: "No shipments yet",
    retry: "Retry",
    loadError: "Could not load history",
    orderPicker: {
      title: "Select order",
      empty: "No packed orders pending shipment",
      error: "Could not load orders",
      retry: "Retry",
    },
  },
  create: {
    title: "New shipment",
    fromOrder: "From order",
    manual: "Manual customer",
    origin: "Origin",
    destination: "Destination",
    customerName: "Customer name",
    customerPhone: "Phone",
    customerEmail: "Email",
    customerAddress: "Address",
    addressDetails: "Address details",
    customerCity: "City",
    deliverySize: "Package size",
    deliveryType: "Service type",
    provider: "Provider",
    pickupDate: "Pickup date",
    calculate: "Get quote",
    continue: "Continue to checkout",
    selectProvider: "Select a provider",
    validationError: "Complete all required fields",
    geocode: "Find coordinates",
    geocodeSuccess: "Address found",
    noSizes: "No package sizes configured. Check delivery settings.",
    noProviders: "No providers available for this delivery type.",
    providersEmptyTitle: "No carriers available",
    providersEmptyMessage:
      "Make sure your origin address is complete and has the correct coordinates. Update it and get a new quote.",
    providersEmptyButton: "Edit origin address",
    goToSettings: "Go to settings",
    productsAlertMessage:
      "Select the *actual package size* based on your product dimensions. An incorrect size may result in *additional charges* from the carrier.",
    orderDetail: "Order details",
    orderDetailHint: "Briefly describe what you are shipping (products, quantity, etc.)",
    location: {
      mapTitle: "Confirm location",
      mapConfirm: "Confirm location",
      mapHint: "Move the map to align the pin with the exact address",
      locationCardHint: "Confirm the location on the map to continue",
      locationConfirmed: "Location confirmed",
      adjustOnMap: "Adjust on map",
      selectCityFirst: "Select a city first",
      confirmOnMapRequired: "Pending map confirmation",
    },
  },
  checkout: {
    title: "Confirm shipment",
    summary: "Summary",
    confirm: "Create shipment",
    pay: "Go to payment",
    recreate: "Retry creation",
    error: "Failed to create shipment",
    success: "Shipment created successfully",
    addressesTitle: "Addresses",
    addressesSubtitle: "Shipment origin and destination",
    originAddress: "Origin address",
    destinationAddress: "Destination address",
    informationTitle: "Shipment information",
    clientName: "Customer name",
    clientPhone: "Customer phone",
    orderDetail: "Order details",
    productsCount: "Products ({{count}})",
    costTitle: "Shipping cost",
    subtotal: "Subtotal",
    total: "Total",
    linkedOrder: "Order #{{orderId}}",
    payTitle: "Shipment payment",
    paymentMethod: "Payment method",
    cancelAddCard: "Cancel",
    termsPrefix: "By making this payment you agree to the",
    termsSuffix: "of the platform",
  },
  detail: {
    title: "Shipment details",
    status: "Status",
    tracking: "Track shipment",
    guide: "View guide",
    manifest: "View manifest",
    pay: "Pay shipment",
    cancel: "Cancel shipment",
    cancelConfirm: "Are you sure you want to cancel this shipment?",
    refresh: "Refresh",
    support: "Contact support",
    customer: "Customer",
    cost: "Shipping cost",
  },
  orders: {
    createShipment: "Create shipment",
    viewShipment: "View shipment",
  },
  logisticStates: {
    notCreated: "Not created",
    calculated: "Quoted",
    created: "Created",
    assigned: "Assigned",
    pendingPayment: "Pending payment",
    successPayment: "Payment successful",
    pending: "Pending",
    inProgress: "In progress",
    finished: "Finished",
    cancelled: "Cancelled",
    error: "Error",
  },
};

export default delivery;
